import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";


import halfday from "../../assets/images/half-time.svg";
const Rwabulkexcelattendancehr = () => {
  const [groupedJson, setGroupedJson] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewCount, setPreviewCount] = useState(0);
  const currentYear = new Date().getFullYear();
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [years, setYears] = useState(currentYear.toString());
  const currentMonth = new Date().getMonth() + 1;
  const [months, setMonths] = useState(currentMonth.toString());
  const { password, username } = billpunchbasicauth;
  
  const convertToDateMap = (attendanceList, year, month) => {
    const daysInMonth = new Date(year, month, 0).getDate();

    const result = {};
    for (let i = 1; i <= daysInMonth; i++) {
      const d = String(i).padStart(2, "0");
      result[d] = { in_time: "", out_time: "", status: "" };
    }
    attendanceList.forEach((a) => {
      const day = a.attendance_date.split("-")[2]; 
      result[day] = {
        in_time: a.in_time,
        out_time: a.out_time,
        status: a.attendance_status,
      };
    });

    return result;
  };

  const fetchRawAttendance = async () => {
    setTransactionLoaderState(true);
    setError("");
    setSuccess("");

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}api/SuperAdmin/GetRawAttendance?firmid=${user?.firm_id}&month=${months}&year=${years}`,
        {
          method: "POST", // MUST BE GET (your API does not accept POST)
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();
      console.log("Raw Attendance Response:", data);

      if (data.status === "0") {
        setSuccess("Attendance fetched successfully!");

        const finalData = data.data.map((emp) => {
          // Parse string JSON
          let list = JSON.parse(emp.attendance_list);

          // SORT BY DATE PROPERLY
          list.sort(
            (a, b) => new Date(a.attendance_date) - new Date(b.attendance_date)
          );

          // Map to correct 01–31 structure
          const mappedDates = convertToDateMap(list, years, months);

          return {
            ...emp,
            attendance_map: mappedDates, // Ready for UI mapping
          };
        });

        setGroupedJson(finalData);
      } else {
        setError(data.msg || "Failed to load attendance.");
      }
    } catch (err) {
      setError("API Error: " + err.message);
    }

    setTransactionLoaderState(false);
  };
  const dayList = React.useMemo(() => {
    if (!months || !years) return [];

    const totalDays = new Date(years, months, 0).getDate();
    const arr = [];

    for (let d = 1; d <= totalDays; d++) {
      const day = d < 10 ? `0${d}` : `${d}`;
      arr.push(day);
    }

    return arr;
  }, [months, years]);

  return (
    <div className="m-3">
       <h5 className="mt-5">Raw Attendance</h5>
      <div className="row mt-3">
        <div className="col-md-10 col-12 p-0 d-flex align-items-center">
          <div className="px-md-2">
            <select
              value={years}
              style={{
                width: "7rem",
                height: "2rem",
                borderRadius: ".4rem",
                border: "1px #ced4da solid",
              }}
              onChange={(e) => setYears(e.target.value)}
            >
              <option value="" disabled>
                Select Year
              </option>{" "}
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
            </select>
          </div>
          <div className="px-md-2">
            <select
              value={months}
              style={{
                width: "7rem",
                height: "2rem",
                borderRadius: ".4rem",
                border: "1px #ced4da solid",
              }}
              onChange={(e) => setMonths(e.target.value)}
            >
              <option value={2023}>Month</option>
              <option value={1}>January</option>
              <option value={2}>February</option>
              <option value={3}>March</option>
              <option value={4}>April</option>
              <option value={5}>May</option>
              <option value={6}>June</option>
              <option value={7}>July</option>
              <option value={8}>August</option>
              <option value={9}>September</option>
              <option value={10}>October</option>
              <option value={11}>November</option>
              <option value={12}>December</option>
            </select>
          </div>
          <button
            onClick={fetchRawAttendance}
            className="btn btn-primary btn-sm"
            style={{ marginLeft: "10px" }}
          >
            Fetch Attendance
          </button>
        </div>
        <div className="col d-flex justify-content-end">
          <Link to="/Hr/AttendanceManagement">
            <Button
              className="btn-sm"
              style={{
                cursor: "pointer",
                border: "1px solid",
                backgroundColor: "rgba(43, 193, 85, 0.1)",
                color: "rgba(43, 193, 85, 1)",
                bordercolor: "rgba(43, 193, 85, 1)",
                borderRadius: ".4rem",
              }}
            >
              Back
            </Button>
          </Link>
        </div>
      </div>
      {groupedJson && (
        <div className="mt-3">
          <div className="accordion" id="attendanceAccordion">
            {groupedJson.map((emp, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`emp-${index}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${index}`}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        flexGrow: 1,
                        whiteSpace: "nowrap", 
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <b>{emp.employee_name}</b>{" "}
                      <span style={{ fontSize: ".8rem" }}>
                        ({emp.employee_designation})
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "18px",
                        alignItems: "center",
                        whiteSpace: "nowrap", 
                      }}
                    >
                      <span style={{ display: "flex", alignItems: "center" }}>
                      Half Day -
                        <span style={{ marginLeft: "6px" }}>
                          {emp.total_halfday}
                        </span>
                      </span>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        Late - 
                        <span style={{ marginLeft: "6px" }}>
                          {emp.total_late}
                        </span>
                      </span>
                      &nbsp;
                    </div>
                  </button>
                </h2>

                <div
                  id={`collapse-${index}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#attendanceAccordion"
                >
                  <div className="accordion-body">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {dayList.map((d) => (
                              <th key={d}>{d}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
  <tr>
    {dayList.map((d) => {
      const att = emp.attendance_map[d] || {};
      let statusText = "";
      let statusColor = "";

      if (att.status === "Y") {
        statusText = "Present";
        statusColor = "green";
      } else if (att.status === "N") {
        statusText = "Absent";
        statusColor = "red";
      }

      return (
        <td 
          key={d} 
          style={{ fontSize: '12px', textAlign: 'center' }}
        >
          {att.in_time || att.out_time || att.status ? (
            <>
              {att.in_time || "-"} - {att.out_time || "-"} (
              <span style={{ color: statusColor }}>{statusText}</span>)
            </>
          ) : (
            "-"
          )}
        </td>
      );
    })}
  </tr>
</tbody>


                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
};

export default Rwabulkexcelattendancehr;
